import { render } from "./Respuesta_PlaDetObs.vue?vue&type=template&id=07b88c41"
import script from "./Respuesta_PlaDetObs.vue?vue&type=script&lang=js"
export * from "./Respuesta_PlaDetObs.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__